import React from 'react';
import './Footer.css';
import logoImg from '../assets/images/MAISON.png';

// Import Font Awesome icons
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTiktok } from '@fortawesome/free-brands-svg-icons';
import { faFacebookF } from '@fortawesome/free-brands-svg-icons';
import { faInstagram } from '@fortawesome/free-brands-svg-icons';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';

const Footer = () => {
    return (
        <footer className="footer">
            <div className="footer-container">
                <div className="footer-grid">
                    {/* Column 1 - About with Logo */}
                    <div className="footer-col">
                        <img 
                            src={logoImg} 
                            alt="Maison Mosh" 
                            className="footer-logo"
                        />
                        <p>Your home away from home in the heart of Lesotho. Experience comfort, luxury, and genuine Basotho hospitality.</p>
                    </div>

                    {/* Column 2 - Quick Links */}
                    <div className="footer-col">
                        <h3>Quick Links</h3>
                        <ul className="footer-links">
                            <li><a href="/">Home</a></li>
                            <li><a href="/about">About Us</a></li>
                            <li><a href="/rooms">Rooms</a></li>
                            <li><a href="/gallery">Gallery</a></li>
                            <li><a href="/contact">Contact</a></li>
                        </ul>
                    </div>

                    {/* Column 3 - Contact Info */}
                    <div className="footer-col">
                        <h3>Contact Info</h3>
                        <ul className="contact-info">
                            <li>
                                <span className="label">Address:</span>
                                <span className="value">31 Mopeli Street</span>
                            </li>
                            <li>
                                <span className="label"></span>
                                <span className="value">Moshoeshoe II, Maseru 100, Lesotho</span>
                            </li>
                            <li>
                                <span className="label">Phone:</span>
                                <span className="value">
                                    <a href="tel:+26656333882">+266 56 333 882</a>
                                </span>
                            </li>
                            <li>
                                <span className="label"></span>
                                <span className="value">
                                    <a href="tel:+26662144500">+266 62 144 500</a>
                                </span>
                            </li>
                            <li>
                                <span className="label">Email:</span>
                                <span className="value">info@maisonmosh.co.ls</span>
                            </li>
                            <li>
                                <span className="label">Check-in:</span>
                                <span className="value">2:00 PM</span>
                            </li>
                            <li>
                                <span className="label">Check-out:</span>
                                <span className="value">10:00 AM</span>
                            </li>
                        </ul>
                    </div>

                    {/* Column 4 - Connect With Us */}
                    <div className="footer-col">
                        <h3>Connect With Us</h3>
                        <div className="social-media-links">
                            {/* TikTok */}
                            <a 
                                href="https://vt.tiktok.com/ZS4hv6Wxt/" 
                                className="social-media-link tiktok"
                                aria-label="TikTok"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <FontAwesomeIcon icon={faTiktok} />
                            </a>
                            {/* Facebook */}
                            <a 
                                href="https://www.facebook.com/share/1JapPf3TDy/" 
                                className="social-media-link facebook"
                                aria-label="Facebook"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <FontAwesomeIcon icon={faFacebookF} />
                            </a>
                            {/* Instagram */}
                            <a 
                                href="https://www.instagram.com/p/Dbfr6XZgMLY/" 
                                className="social-media-link instagram"
                                aria-label="Instagram"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <FontAwesomeIcon icon={faInstagram} />
                            </a>
                            {/* WhatsApp */}
                            <a 
                                href="https://wa.me/26656333882" 
                                className="social-media-link whatsapp"
                                aria-label="WhatsApp"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <FontAwesomeIcon icon={faWhatsapp} />
                            </a>
                        </div>
                        <div className="footer-phone-numbers">
                            <a href="tel:+26656333882">+266 56 333 882</a>
                            <span className="separator">|</span>
                            <a href="tel:+26662144500">+266 62 144 500</a>
                        </div>
                    </div>
                </div>

                {/* Bottom Bar */}
                <div className="footer-bottom">
                    <p>&copy; {new Date().getFullYear()} Maison Mosh Guest House. All rights reserved.</p>
                    <div className="footer-bottom-links">
                        <a href="/privacy">Privacy Policy</a>
                        <a href="/terms">Terms & Conditions</a>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;